import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "contextModal", "wrapper", "mask" ]
  
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.contextModalTarget.classList.toggle("active")
  }
  
  show(event) {
    event.preventDefault();
    event.stopPropagation();
    let trigger = event.target.closest(".actions--context-modal__trigger")

    this.contextModalTarget.classList.add("active")

    const rect = trigger.getBoundingClientRect()
    const modalHeight = this.wrapperTarget.offsetHeight
    const windowHeight = window.innerHeight
    
    let left = rect.left + rect.width
    let top
    
    // Check if showing below would go outside window boundary
    if (rect.bottom + modalHeight + 10 > windowHeight) {
      // Position above the trigger
      top = rect.top - modalHeight - 10
    } else {
      // Position below the trigger (original behavior)
      top = rect.top + rect.height + 10
    }

    this.wrapperTarget.style.left = `${left}px`;
    this.wrapperTarget.style.top = `${top}px`;
  }

  hide(event) {
    if (!event.target.hasAttribute("data-turbo-method")) {
      event.stopPropagation();
    }
    this.contextModalTarget.classList.remove("active")
  }  
}
